import React from 'react';

const BarcodeLastIndexContext = React.createContext();

export default BarcodeLastIndexContext;
